export function formatFullName(
  lastName?: string | null,
  firstName?: string | null,
  patronymic?: string | null,
): string {
  const parts = [lastName, firstName, patronymic].map((p) => (typeof p === 'string' ? p.trim() : '')).filter(Boolean);
  return parts.join(' ');
}
